module.exports = __webpack_public_path__ + "static/media/dorvenretail.8f7a010b.png";